import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ModalComponent } from "./modal/modal.component";
import { ToastComponent } from "./toast/toast.component";
import { SharedModule } from "../shared.module";
import { NavigationGroupComponent } from "./navigation-group/navigation-group.component";
import { UserProfileWithAvatarComponent } from "./user-profile-with-avatar/user-profile-with-avatar.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";

@NgModule({
  declarations: [
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    ModalComponent,
    ToastComponent,
    NavigationGroupComponent,
    UserProfileWithAvatarComponent,
    UserProfileComponent,
    ToastComponent,
    ToastComponent
  ],
  exports: [
    SharedModule,
    CommonModule,
    RouterModule,
    ModalComponent,
    ToastComponent,
    NavigationGroupComponent,
    UserProfileWithAvatarComponent,
    UserProfileComponent,
    ToastComponent,
    ToastComponent
  ]
})
export class SharedComponentsModule { } 